var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg3DotsVertical = function Svg3DotsVertical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5.723,
    height: 23.148,
    viewBox: "0 0 5.723 23.148",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dadada;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.017, 1, -1, 0.017, 194.673, -325.296)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.661,
    cy: 2.661,
    r: 2.661,
    transform: "translate(327.263 200.322) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.661,
    cy: 2.661,
    r: 2.661,
    transform: "translate(336.132 200.322) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.661,
    cy: 2.661,
    r: 2.661,
    transform: "translate(345 200.322) rotate(180)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3DotsVertical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3dotsVertical.a0bc1b90.svg";
export { ForwardRef as ReactComponent };